/*
 * Copyright (c) 2024.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  CLEAR_KEY,
  KEY_UPDATE, SINGLE_KEY_UPDATE,
} from './types';

export function updateKeyRequest(data) {
  return {
    type: KEY_UPDATE,
    data,
  };
}

export function updateSingleKeyRequest(data) {
  return {
    type: SINGLE_KEY_UPDATE,
    data
  }
}

export function clearKeyRequet() {
  return { type: CLEAR_KEY }

}